<template>
  <div v-if="isShowing" class="alert alert-dismissible" :class="`alert-${alertType}`" role="alert">
    <button
      @click="closeAction"
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close"
      v-if="dismissible"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="content-container">
      <img :class="{ 'alert-with-notice': notice }" v-if="showIcon" :src="getAlertImageUrl()" alt="payment" width="50" height="50">
      <div class="text-container">
        <p class="title">
          <strong>{{title}}</strong>
        </p>
        <p class="subtitle">{{subtitle}}</p>
        <p class="notice">{{notice}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DismissableAlert',
  props: {
    alertType: {
      type: String,
      required: false,
      default: 'success',
    },
    isShowing: {
      type: Boolean,
      required: true,
      default: false,
    },
    closeAction: {
      type: Function,
      required: false,
      default: () => {},
    },
    title: {
      type: String,
      required: true,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    dismissible: {
      type: Boolean,
      required: false,
      default: true,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    notice: {
      type: String,
      default: null,
      required: false,
    },
  },
  methods: {
    getAlertImageUrl() {
      return require(`@/assets/img/icon-${this.icon}.svg`); // eslint-disable-line
    },
  },
};
</script>

<style scoped>
.title {
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 5px;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  padding-right: 35px;
}

.content-container {
  display: flex;
}

.text-container {
  margin-left: 10px;
}

.notice {
  font-weight: 800;
}

.subtitle {
  margin: 0;
}

.alert-with-notice {
 margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// DismissableAlert.vue?40301f38